import { getAccountBalance } from "../../api/modules/b2droppie.class";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { trackDepositClick } from "../../utils/GoogleTagTracking";

export const fetchBalance = createAsyncThunk(
  "account/fetchBalance",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await getAccountBalance({ id: userId });
      return response?.data?.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to fetch balance");
    }
  },
);

const initialState = {
  level: 0,
  balance: 0,
  current_xp: 0,
  next_level: 0,
  payment: false,
  searchModal: false,
  next_level_xp: 0,
  xp_percentage: 0,
  activeTab: "deposit",
  formatted_balance: "0",
};

export const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setAccount: (state, action) => {
      return { ...state, ...action.payload };
    },

    togglePayment: (state, action) => {
      const payment = action?.payload?.payment ?? false;
      state.payment = payment;

      if (payment) {
        trackDepositClick();
      }
    },

    toggleSearchModal: (state, action) => {
      state.searchModal = action?.payload ?? !state.searchModal;
    },

    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchBalance.fulfilled, (state, action) => {
      return { ...state, ...action.payload };
    });
  },
});

export const {
  setAccount,
  togglePayment,
  setActiveTab,
  toggleSearchModal,
} = accountSlice.actions;
export default accountSlice.reducer;
